const fixLockedTextValue = text => {
  return text
    .replace(/≥[^≥]*?≥/g, "") // removed
    .replace(/[≤≥]/g, ""); // added
};

export default fixLockedTextValue;
